module.exports = __webpack_public_path__ + "static/media/icon_system_social_linkedin.ca40afd1.svg";